import UserInputResult from "./UserInputResult";


export function calcMaxAnswersCount(userInputResult, question)
{
    const userInputCount = userInputResult.userInputCount()
    const durationInMilliSec = question.duration() * 1000
    const paceDurationInMilliSec = question.durationBetweenOptions(userInputResult.pace)

    const expectedAnswersCount = Math.ceil(durationInMilliSec / paceDurationInMilliSec)

    const userInputRatio = 100 / expectedAnswersCount * userInputCount

    return userInputRatio<85 ? expectedAnswersCount : userInputCount
}

export const percentagePointsReached = function(userInputResult, question)
{
    const correctUserInputCount = userInputResult.correctUserInputCount()

    const maxAnswersCount   = calcMaxAnswersCount(userInputResult, question)

    return Math.trunc(100 / maxAnswersCount * correctUserInputCount)
}


export const calculatePoints = function(answer)
{
    const question = answer.question()
    const userInput = answer.userInput()[0]
    const userInputResult = new UserInputResult()

    userInputResult.resetResultStructureWith(userInput ? userInput.value: null)

    const points            = Number(question.points())
    const percentageReached = percentagePointsReached(userInputResult, question)
    const pointsReached     = points / 100 * percentageReached

    return Math.trunc(percentageReached>=90 ? points : pointsReached)
}